// eslint-disable-next-line no-unused-vars
/*global chrome */
import React, { Component } from 'react';
import ScreenshotsContainer from './containers/ScreenshotsContainer/ScreenshotsContainer'
import ImageContainer from './containers/ImageContainer/ImageContainer';
import Button from './components/UI/Button/Button'
import classes from './App.module.css';
import { CSSTransition } from 'react-transition-group'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import triggerPlay from './util';


class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imgURIArray: [],
            img: null,
            showImageContainer: false,
            showScreenshotContainer: false,
            selectedImageURI: null,
            showSaveAnimation: false,
            showNotify: false,
            pauseOnShot: true
        }
    }

    componentDidMount() {
        var self = this;
        window.addEventListener("message", function (event) { //listen for messages from react app
            // We only accept messages from ourselves
            if (event.source !== window)
                return;

            if (event.data.type && (event.data.type === "FROM_EXTENSION")) {
                // console.log("React app received message: " + event.data.image);
                self.setState({ img: event.data.image, showImageContainer: true })
            }
        });
        this.notify(this.state.pauseOnShot, this.state.pauseOnShot ? "Pause-on-shot is ON." : "Pause-on-shot is OFF.", 2000);
    }

    // getBoxDimensions = () => {
    //     let element = document.getElementById('qa_films');
    //     let dimensions = element.getBoundingClientRect()//get size of iframe for reference
    //     console.log(element.getBoundingClientRect())    
    //     return dimensions;
    // }

    storeImageToArrayHandler = (imgURI) => {
        if (imgURI !== "") {
            this.setState({ imgURIArray: [...this.state.imgURIArray, imgURI] }, () => {
                this.setState({ showImageContainer: !this.state.showImageContainer })
            })
        }
    }

    getScreenshotHandler = () => {
        // These 2 lines communicate with content_script.js that's from the extension
        var data = { type: "FROM_PAGE", text: "Screenshot Request" };
        window.postMessage(data, "*");

        this.notify(true, "Screenshot Taken. Nice!")
        if (this.state.pauseOnShot) {
            triggerPlay();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("message");
    }

    getSelectedImageFromContainerHandler(selectedImageURI) {
        this.setState({
            selectedImageURI: selectedImageURI,
            showImageContainer: !this.state.showImageContainer
        })
    }

    showImageContainerHandler(showImageContainer) {
        this.setState({ showImageContainer: showImageContainer })
    }

    showScreenshotContainerHandler = () => {
        this.setState({ showScreenshotContainer: !this.state.showScreenshotContainer })
    }

    notify = (submitSuccessful, msg, duration) => {
        duration = duration ? duration : 1000
        let message = msg ? msg : ""

        const toastParams = {
            pauseOnHover: false,
            pauseOnFocusLoss: false,
            draggable: false,
            autoClose: duration,
            position: toast.POSITION.BOTTOM_CENTER
        }

        submitSuccessful ?
            toast.success(message, toastParams)
            :
            toast.error(message, toastParams);
    }

    triggerPauseOnShot = () => {
        this.setState({ pauseOnShot: !this.state.pauseOnShot }, () => {
            this.notify(this.state.pauseOnShot, this.state.pauseOnShot ? "Pause-on-shot is ON." : "Pause-on-shot is OFF.");
        })
    }
    render() {
        let buttonOps = (
            <CSSTransition
                in={!this.state.showScreenshotContainer}
                appear={true}
                timeout={300}
                classNames="fade"
            >
                <div className={classes.optionButtons}>
                    <Button icon={"fas fa-camera"} type={"button-success"} gridClass={""} buttonName={""} style={{ width: "66.33%", height: "70px" }} onClick={() => this.getScreenshotHandler} />
                    <Button icon={"far fa-handshake"} type={"button-error"} gridClass={""} buttonName={""} style={{ width: "66.33%", height: "70px" }} onClick={() => this.triggerPauseOnShot} />
                    <Button icon={"fas fa-images"} type={"button-primary "} gridClass={""} buttonName={""} style={{ width: "66.33%", height: "70px" }} onClick={() => this.showScreenshotContainerHandler} />

                    {/* <Button icon={"fas fa-camera"} type={"button-success"} gridClass={""} buttonName={""} style={{ width: "100%", height: "70px" }} onClick={() => this.getScreenshotHandler} />
                    <Button icon={"fas fa-images"} type={"button-primary "} gridClass={""} buttonName={""} style={{ width: "100%", height: "70px" }} onClick={() => this.showScreenshotContainerHandler} /> */}
                </div>
            </CSSTransition>
        )

        return (
            <div>
                {
                    this.state.showImageContainer ?

                        <ImageContainer
                            img={this.state.img}
                            showImageContainer={showImageContainer => this.showImageContainerHandler(showImageContainer)}
                            storeImageToArrayHandler={imgURI => this.storeImageToArrayHandler(imgURI)}
                            notify={(submitSuccessful, msg) => this.notify(submitSuccessful, msg)}

                            pauseOnShot={this.state.pauseOnShot}
                        />
                        : null
                }
                <CSSTransition
                    in={this.state.showScreenshotContainer}
                    appear={true}
                    timeout={300}
                    classNames="slide"
                    unmountOnExit
                    onExited={() => {
                        this.setState({ showScreenshotContainer: false })
                    }}
                >
                    <ScreenshotsContainer
                        imgURIArray={this.state.imgURIArray}
                        getSelectedImageFromContainerHandler={imgURI => this.getSelectedImageFromContainerHandler(imgURI)}
                        showScreenshotContainerHandler={() => this.showScreenshotContainerHandler}
                        notify={(submitSuccessful, msg) => this.notify(submitSuccessful, msg)}
                    />

                </CSSTransition>
                {this.state.showImageContainer ? null : buttonOps}
                {/* <button onClick={this.notify}>Notify !</button> */}
                <ToastContainer />
            </div >
        );
    }
}

export default App;
